import React, { useCallback, useRef } from "react";

import { CircularProgress, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroll-component";

import Game from "../../../../Game";
import useStyles from "./Search.styles";
import { getSearchedGamesStart } from "../../../../../../redux-saga/redux/casino/lobby/casinoGames";
import { formatCategoryName } from "../../../../../../utils/helper";

const GamesSection = ({
  selectedCategory,
  selectedProvider,
  searchInput,
  // offset,
  makeProviderCategoryFilter,
  setShowSearch
}) => {
  const classes = useStyles();
  const {
    searchGames,
    searchLoading,
    searchCount,
    searchNoOfPages,
    searchPage
  } = useSelector((state) => state.casinoGames);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const offset = useRef(1);

  const checkFilterSelected = useCallback(() => {
    if (
      !Object.keys(selectedProvider).length &&
      !Object.keys(selectedCategory).length &&
      !searchInput.trim().length
    ) {
      return true;
    }
    return false;
  }, [searchInput, selectedProvider, selectedCategory]);

  const providerCategoryFilter = makeProviderCategoryFilter();

  return (
    <>
      <Grid>
        {checkFilterSelected() ? (
          <Grid textAlign="center" className={classes.searchImg}>
            <img src="/images/no-search-img.webp" alt="Search" />
            <br />
            {t("LOBBY.NO_FILTER_SELECTED_MSG")}
          </Grid>
        ) : (
          <>
            {searchLoading && offset.current == 1 ? (
              <Grid container spacing={2} className={classes.searchGames}>
                <CircularProgress className={classes.searchLoader} />
              </Grid>
            ) : searchGames?.length > 0 ? (
              <InfiniteScroll
                id="scrollableDiv"
                dataLength={searchGames?.length}
                //This is important field to render the next data
                next={() => {
                  if (searchPage == 1) {
                    offset.current = 1;
                  }
                  if (!searchLoading && offset.current <= searchNoOfPages) {
                    offset.current += 1;
                    dispatch(
                      getSearchedGamesStart({
                        isMobile,
                        page: offset.current,
                        limit: isMobile ? 8 : 12,
                        search: searchInput.trim().length ? searchInput : null,
                        ...providerCategoryFilter
                      })
                    );
                  }
                }}
                height={350}
                hasMore={searchGames?.length == searchCount ? false : true}
                loader={
                  <Grid textAlign="center">
                    <CircularProgress
                      className={classes.categoryLoader}
                      size={50}
                    />
                  </Grid>
                }
                endMessage={
                  <p style={{ textAlign: "center" }}>
                    <b>{t("LOBBY.YOU_HAVE_SEEN_IT_ALL")}</b>
                  </p>
                }
              >
                <Grid
                  container
                  // spacing={2}
                  className={`${
                    !searchGames?.length ? classes.searchGames : ""
                  } modalGameList`}
                >
                  {searchGames.map((game, index) => (
                    <Game
                      key={`${game.masterCasinoGameId}${index}`}
                      thumbnailUrl={game.thumbnailUrl || game.gameImage}
                      name={game.name}
                      gameId={game.masterCasinoGameId}
                      setShowSearch={setShowSearch}
                      providerName={game?.MasterCasinoProvider?.name}
                      categoryName={formatCategoryName(
                        game?.MasterGameSubCategory?.name
                      )}
                      gameTag={game.tags}
                      isFavorite={game?.isFavorite}
                    />
                  ))}
                </Grid>
              </InfiniteScroll>
            ) : (
              <Grid className={classes.searchImg}>
                <img src="/images/no-search-img.webp" alt="Search" />
                <br />
                {t("LOBBY.NO_RESULTS_FOUND")}
              </Grid>
            )}
          </>
        )}
      </Grid>
    </>
  );
};

export default GamesSection;
